module.exports = __webpack_public_path__ + "static/img/person.171dda42.png";